"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockOrderLineItem = exports.mockOrder = void 0;
function mockOrder(overrides = {}) {
    return {
        created_at: '2019-03-22T10:28:06-05:00',
        fulfillments: [],
        id: 987654321,
        line_items: [mockOrderLineItem()],
        number: '123456789',
        name: '#1234',
        order_status_url: 'https://shop.omniafishing.com/123456789/orders/jaklfjalejkaljgkljavnvaljk3lk3j5kl2jln',
        refunds: [],
        subtotal_price: '9.99',
        total_line_items_price: '9.99',
        total_discounts: '0.00',
        total_price: '10.99',
        total_tax: '1.00',
        total_shipping_price_set: {
            shop_money: {
                amount: '5.00',
            },
            presentment_money: {
                amount: '5.00',
            },
        },
        ...overrides,
    };
}
exports.mockOrder = mockOrder;
function mockOrderLineItem(overrides = {}) {
    return {
        discount_allocations: [
            {
                amount: '1.70',
                amount_set: {
                    presentment_money: {
                        amount: '1.70',
                        currency_code: 'USD',
                    },
                    shop_money: {
                        amount: '1.70',
                        currency_code: 'USD',
                    },
                },
                discount_application_index: 0,
            },
        ],
        fulfillment_service: 'manual',
        fulfillment_status: null,
        gift_card: false,
        grams: 0,
        id: 2221294682169,
        name: 'Rapala Jigging Rap - 2-3/4" / GLOW YELLOW PERCH',
        pre_tax_price: '5.09',
        price: '6.79',
        product_exists: true,
        product_id: 1718717972537,
        properties: [],
        quantity: 1,
        requires_shipping: true,
        sku: 'HB-BB-RP-0042',
        taxable: true,
        title: 'Rapala Jigging Rap',
        total_discount: '0.00',
        total_discount_set: {
            presentment_money: {
                amount: '0.00',
                currency_code: 'USD',
            },
            shop_money: {
                amount: '0.00',
                currency_code: 'USD',
            },
        },
        variant_id: 16933463851065,
        variant_title: '2-3/4" / GLOW YELLOW PERCH',
        vendor: 'Rapala',
        ...overrides,
    };
}
exports.mockOrderLineItem = mockOrderLineItem;
